import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from "ag-grid-react";
import { columnSecMaster } from "../../../common/columnSecMaster";
import _ from "lodash";
import "./style.css";
import "../../../common/style.css";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../components/AgGrid/grid-util";
import { useLocation } from "react-router";
import { constants } from "../../../common/constants";
import { getRowStyle } from "../../../common/commonFunctions";

interface AgGridProps {
  title?: string;
  rowData: any;
  height?: any;
  type?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  isSingleRowInserted?: boolean
  defaultFilter?: any
}

const SecMasterGrid = ({
  title,
  rowData,
  height,
  type,
  onClickHan,
  onClickSelectData,
  onCellChange,
  seTtotalSelectedRows,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  isSingleRowInserted,
  defaultFilter,
}:
  AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...columnSecMaster]);
  const [selectedData, setSelectedData] = useState<any>([]);
  // const [gridApiParmas, setGridApiParams] = useState<any>(null);

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: false,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);

  useEffect(() => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getUpdatedData();
    getName(gridApi, gridColumnApi);
    getBtnRef(gridRef);
  }, [rowData]);

  const onColumnResized = useCallback((params: ColumnResizedEvent) => { }, []);

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    getName(gridApi, gridColumnApi);
    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    api.deselectAll();
    getName(api, columnApi);
  };

  const { pathname } = useLocation();
  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    if (pathname && typeof pathname === "string") {
      const pathsToSkip = ["secmaster", "counterParty"];
      for (let aPath of pathsToSkip) {
        if (pathname.endsWith(aPath)) return true;
      }
    }

    //Skip for Contract Activity Popup
    if (type === constants.ContractActivity) return true;

    if (
      type === constants.DtcSummary ||
      type === constants.DtcOut ||
      type === constants.DtcIn
    ) {
      return true;
    }

    return false;
  };

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "select",
      "value",
      "daily_accruals",
      "contract_value",
      "daily_accrual",
      "contract_id",
    ];
    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    let contractIdTotal = ["contract_id"];
    let countContractId_ = 0;
    contractIdTotal.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        countContractId_++;
        if (rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    rows["contract_id"] = countContractId_;

    var count = Number(2);
    for (var i = 0; i < count; i++) {
      if (i === 0) {
        result.push({
          select: "Selected",
          cpty_name: "Total CPTY",
          cpty_id: null,
          div: null,
          quantity: null,
          mark: undefined,
          cusip: null,
          ticker_price: null,
          tb_ticker: "Total Symbol",
          ticker: "Total Symbol",
          value: "Total Value",
          contract_value: "Total Value",
          daily_accrual: "Total Accrual",
          // contract_price: "Total Price",
          daily_accruals: "Total Accrual",
          recall: "Total Recall",
          recall_date: null,
          exp_date: null,
          c_n: null,
          // Collatoral_code: "Total Collatoral",
          contract_id: "Total Contracts",
          isTotalRow: true,
          // rate: "Avg Rate",
        });
      } else {
        rows["isTotalRow"] = true;
        rows["tb_ticker"] = countUnique("tb_ticker", api);
        rows["ticker"] = countUnique("ticker", api);
        // rows["tb_ticker"] = countTBTICKER();
        // rows["ticker"] = countTBTICKER();
        // rows["Collatoral_code"] = countColla();
        rows["cpty_name"] = countUnique("cpty_name", api);
        //const selectedRows = gridRef.current!.api.getSelectedRows();
        //rows["select"] = countUnique('select',api);
        rows["select"] = countRows("select", api);
        // rows["cpty_name"] = countCPTY();
        // rows["contract_id"] = countContractId();
        rows["recall"] = countRecall();
        // rows["rate"] = countRate();
        rows["mark"] = undefined;
        result.push(rows);
      }
    }
    api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (rowNode?.data instanceof Object && attribute in rowNode.data) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };

  useEffect(() => {
    if (isDeselectAll != undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const countRows = (rowNode: any, api: GridApi): number => {
    const selectedRows: any = gridRef.current!.api.getSelectedRows();
    if (selectedRows.length === 0) {
      return 0;
    } else {
      return selectedRows.length;
    }
  };

  const countRecall = () => {
    const rowData: any = [];
    const recallCount = new Set();
    gridApi?.forEachNode((node: any) => rowData.push(node.data));
    rowData.map((obj: any) => {
      if (obj) {
        recallCount.add(obj.recall);
      }
    });
    return recallCount.size;
  };

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        var isNew = params.data.is_new;
        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        var isNew = params.data.is_Recall;
        return isNew === "True";
      },
    };
  }, []);

  const onSelectionChanged = useCallback((params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedRows();
    const { api, columnApi } = params;
    getName(api, columnApi);
    setSelectedData(selectedRows);
    let tempArray: any = [];
    gridApi = gridRef.current!.api;
    gridApi.forEachNodeAfterFilter((node: any) => {
      tempArray.push(node.data);
    });

    let rowDataClear = selectedRows.filter((val: any) => {
      return !tempArray.includes(val);
    });

    let tempClear = tempArray.filter((val: any) => {
      return !selectedRows.includes(val);
    });
    let finalClear = tempArray.filter((val: any) => {
      return !tempClear.includes(val);
    });
    if (
      tempArray.length < rowDataClear.length ||
      (tempArray.length > rowDataClear.length &&
        rowDataClear.length > 0 &&
        tempArray.length > 0)
    ) {
      setSelectedData(finalClear);
    }
    if (seTtotalSelectedRows != undefined) seTtotalSelectedRows?.(selectedRows);
    onClickHan?.(rowDataClear);
    onClickSelectData?.(finalClear);
  }, []);

  const onCellValueChanged = useCallback(async(event: any) => {
    event.value = event?.value && _.isString(event?.value) ? event?.value?.toUpperCase() : event?.value
    if(event.column === 'ticker'){
      event.value = event?.value?.toUpperCase() 
    }
    await onCellChange(event.data, event?.value, event.column)
  }, []);

  const getUpdatedData = useCallback(async () => {
    await gridApi?.applyTransactionAsync({ update: [rowData] })
    const refreshParams: any = {
      force: true,
      suppressFlash: true
    }
    gridApi?.refreshCells(refreshParams)
  }, [rowData])

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = (params: any) => {
    if (params && params.data) {
      if (params.data.id) {
        return params.data.id;
      }
    }
    return makeid(5);
  };

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  function isForceRefreshSelected() {
    return (document.querySelector("#forceRefresh") as HTMLInputElement)
      ?.checked;
  }
  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  function isSuppressFlashSelected() {
    return (document.querySelector("#suppressFlash") as HTMLInputElement)
      ?.checked;
  }
  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: isForceRefreshSelected(),
      suppressFlash: isSuppressFlashSelected(),
    };
    gridRef.current!.api.refreshCells(refreshParams);
  };

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);
    return true;
  }, []);
  return (
    <div
      className="ag-theme-balham h-100"
      style={{
        width: "100%",
      }}
    >
      {title !== undefined && (
        <div className="drag-handle title-subHeaderTitle"> {title} </div>
      )}
      <AgGridReact
        ref={gridRef}
        rowStyle={{
          justifyContent: "center",
          color: "#2D2D2D",
          fontSize: "0.75rem",
          fontWeight: "400",
          fontStyle: "normal",
        }}
        rowHeight={22}
        columnDefs={columnDefs}
        getRowId={getRowId}
        onRowDataUpdated={onGridRowDataChanged}
        rowData={rowData}
        suppressRowClickSelection={true}
        defaultColDef={defaultColDef}
        suppressAggFuncInHeader={true}
        enableCellChangeFlash={
          _.isUndefined(isSingleRowInserted) || !isSingleRowInserted
        }
        enableRangeSelection={true}
        onGridReady={onGridReady}
        onFilterModified={onFilterModified}
        onFilterChanged={onFilterChanged}
        onGridSizeChanged={onGridSizeChanged}
        onColumnResized={onColumnResized}
        rowClassRules={rowClassRules}
        onSelectionChanged={onSelectionChanged}
        rowSelection={"multiple"}
        getRowStyle={getRowStyle}
        onCellValueChanged={onCellValueChanged}
        autoGroupColumnDef={autoGroupColumnDef}
        groupSelectsChildren={true}
        groupSelectsFiltered={true}
        sideBar={sideBar}
        pivotMode={false}
        cacheQuickFilter={false}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={onDoesfilter}
        getContextMenuItems={getContextMenuItems}
        quickFilterText={globalSearch}
        overlayLoadingTemplate={
          '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
        }
      ></AgGridReact>
    </div >
  );
};

function CustomTooltip() { }

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default SecMasterGrid;
